module.exports = __webpack_public_path__ + "static/img/10.8386ca3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/10.png
// module id = PwbS
// module chunks = 0